import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

export const titleCss: CSSObject = {
  lineHeight: "2rem",
  marginBottom: "1.5rem",
};

export const prosemirrorContainerCss: CSSObject = {
  '[data-prosemirror-node="cards_section"]': {
    padding: 20,
    background: constants.colors.ui.neutral[25],
    border: `1px solid ${constants.colors.ui.neutral[50]}`,
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(278px, 1fr))",
    gap: 18,
    paddingTop: "18px",
    borderRadius: "1rem",

    "> article": {
      minWidth: 0,
    },

    "> div:empty": {
      display: "none",
    },
  },
};
